<form [formGroup]="videoForm">
  <div class="bg-blue-2 d-flex al-center sp-between p-4">
    <div>
      <div>
        <span class="text-white fw-extrabold fs-4">Curso 1</span>
      </div>
      <div>
        <span class="text-white fs-6 fw-regular">Ingresa el título y descripción del curso.</span>
      </div>
    </div>
    <div>
      <img src="assets/svg/Icon_close.svg" mat-dialog-close alt="">
    </div>
  </div>
  <mat-dialog-content class="p-4 d-flex flex-column content-form">
    <div>
      <div>
        <div class="mb-2">
          <span class=" fw-semibold">Título</span>
        </div>
        <input type="text" formControlName="title" class="w-100 border rounded px-3">
      </div>
      <br>
      <div>
        <div class="mb-2">
          <span class=" fw-semibold">Descripción</span>
        </div>
        <textarea type="text" formControlName="description" rows="5" maxlength="500" placeholder="Ingrese descripción del video" class="w-100 border rounded p-3"></textarea>
      </div>
      <br>
      <div>
        <div class="mb-2">
          <span class=" fw-semibold">URL video</span>
        </div>
        <input type="text" formControlName="urlVideo" class="w-100 border rounded px-3">
      </div>
      <br>
      <!-- <div>
        <div class="mb-2">
          <span>Duracion del video</span>
        </div>
        <input type="text" formControlName="timeVideo" class="w-100 border rounded px-3">
      </div> -->
    </div>
  </mat-dialog-content>
  <div class="p-4 text-end content-action">
    <mat-dialog-actions align="end">
      <button mat-flat-button class="bg-blue-2 w-100" (click)="saveDataCourse()">
        <span class="fw-bold fs-5 text-white me-3">Guardar cambios</span>
        <img src="assets/svg/Icon_arrow_right_white.svg" alt="">
      </button>
    </mat-dialog-actions>
  </div>
</form>
<ng-container *ngIf="loader">
  <app-loader></app-loader>
</ng-container>